import { Text, mergeClassNames } from '@clockout-dev/design-elements';
import { DISTRIBUTION_BUCKETS } from '../reviews.constants';
import styles from '../styles/feedback.module.scss';

function formatDelta(delta) {
    if (delta == null) return null;
    const sign = delta > 0 ? '+' : delta < 0 ? '−' : '';
    return `${sign}${Math.abs(delta).toFixed(1)}`;
}

function deltaClass(delta) {
    if (delta == null || delta === 0) return styles.deltaFlat;
    return delta > 0 ? styles.deltaUp : styles.deltaDown;
}

function FeedbackScoreCard({ summary, loading }) {
    const average = summary.average_rating;
    const delta = summary.delta;
    const deltaLabel = formatDelta(delta);

    return (
        <div className={mergeClassNames([styles.card, styles.scoreCard])}>
            {loading ? (
                <>
                    <div className={styles.skeletonLine} style={{ width: 140, height: 72 }} />
                    <div className={styles.skeletonLine} style={{ width: 160, height: 14 }} />
                    <div className={styles.skeletonLine} style={{ width: 180, height: 22 }} />
                </>
            ) : (
                <>
                    <span className={styles.scoreValue}>
                        {average == null ? '—' : Number(average).toFixed(1)}
                    </span>
                    <Text as="span" className={styles.scoreCaption}>
                        Average &middot; scale of 1&ndash;10
                    </Text>
                    {deltaLabel != null && (
                        <div className={styles.deltaRow}>
                            <span className={mergeClassNames([styles.deltaBadge, deltaClass(delta)])}>
                                {deltaLabel}
                            </span>
                            <Text as="span" className={styles.deltaCaption}>
                                vs. prior period
                            </Text>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

function ScoreDistributionCard({ summary, loading }) {
    const distribution = summary.distribution || [];
    const byBucket = distribution.reduce((acc, row) => {
        acc[row.bucket] = row;
        return acc;
    }, {});

    return (
        <div className={mergeClassNames([styles.card, styles.distCard])}>
            <Text as="span" className={styles.distTitle}>Score Distribution</Text>
            <div className={styles.distRows}>
                {DISTRIBUTION_BUCKETS.map(({ bucket, color }) => {
                    const percent = loading ? 0 : (byBucket[bucket]?.percent || 0);
                    return (
                        <div key={bucket} className={styles.distRow}>
                            <span className={styles.distLabel}>{bucket}</span>
                            <div className={styles.distTrack}>
                                <div
                                    className={styles.distFill}
                                    style={{ width: `${percent}%`, background: color }}
                                />
                            </div>
                            <span className={styles.distPercent}>{loading ? '—' : `${percent}%`}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

function FeedbackSummary({ summary = {}, loading = false }) {
    return (
        <div className={styles.leftCol}>
            <FeedbackScoreCard summary={summary} loading={loading} />
            <ScoreDistributionCard summary={summary} loading={loading} />
        </div>
    );
}

export default FeedbackSummary;
